import { useState, useEffect } from 'react'
import PageNavigation from '../../../components/PageNavigation/PageNavigation'
import './Community.css'

const Community = () => {
  const [activeSection, setActiveSection] = useState('overview')

  const sections = [
    { id: 'overview', title: 'Overview' },
    { id: 'join-community', title: 'Join Our Community' },
    { id: 'guidelines', title: 'Community Guidelines' },
    { id: 'resources', title: 'Community Resources' },
    { id: 'contributing', title: 'Contributing' }
  ]

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 200

      for (let i = sections.length - 1; i >= 0; i--) {
        const element = document.getElementById(`community-${sections[i].id}`)
        if (element && element.offsetTop <= scrollPosition) {
          setActiveSection(sections[i].id)
          break
        }
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()
    return () => window.removeEventListener('scroll', handleScroll)
  }, [sections])

  return (
    <div className="community-page">
      <div className="community-content-wrapper">
        <div className="community-main-content">
      <h1>Community</h1>
      <p className="intro">
        Join the Aedify.AI community to connect with other users, share knowledge, and get help.
            Where builders, operators, and partners stay connected.
      </p>

          <section id="community-overview" className="community-section">
            <h2>Overview</h2>
        <p>
          Connect with developers, share your projects, ask questions, and learn from others in 
              the Aedify.AI community. Our community is a space for builders and operators working 
              on AI infrastructure to collaborate, learn, and grow together.
        </p>
          </section>

          <section id="community-join-community" className="community-section">
            <h2>Join Our Community</h2>
            <p>
              Connect with the Aedify.AI community across multiple platforms:
            </p>
            
            <div className="community-icons">
              <div className="community-icon-item">
                <a 
                  href="https://www.linkedin.com/company/aedify-ai/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="community-icon-link"
                >
                  <div className="community-icon-circle">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                      <path d="M21.3335 10.666C23.4552 10.666 25.4901 11.5089 26.9904 13.0092C28.4906 14.5095 29.3335 16.5443 29.3335 18.666V27.9993H24.0002V18.666C24.0002 17.9588 23.7192 17.2805 23.2191 16.7804C22.719 16.2803 22.0407 15.9993 21.3335 15.9993C20.6263 15.9993 19.948 16.2803 19.4479 16.7804C18.9478 17.2805 18.6668 17.9588 18.6668 18.666V27.9993H13.3335V18.666C13.3335 16.5443 14.1764 14.5095 15.6766 13.0092C17.1769 11.5089 19.2118 10.666 21.3335 10.666Z" stroke="#51A2FF" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M7.99984 12H2.6665V28H7.99984V12Z" stroke="#51A2FF" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M5.33317 7.99935C6.80593 7.99935 7.99984 6.80544 7.99984 5.33268C7.99984 3.85992 6.80593 2.66602 5.33317 2.66602C3.86041 2.66602 2.6665 3.85992 2.6665 5.33268C2.6665 6.80544 3.86041 7.99935 5.33317 7.99935Z" stroke="#51A2FF" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </a>
                <h4>LinkedIn</h4>
                <p>Product updates, infrastructure insights, and company news.</p>
              </div>

              <div className="community-icon-item">
                <a 
                  href="https://discord.gg/v39EcyrT" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="community-icon-link"
                >
                  <div className="community-icon-circle">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 14.666H13.3333" stroke="#7C86FF" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M10.6665 12V17.3333" stroke="#7C86FF" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M20 16H20.0133" stroke="#7C86FF" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M24 13.334H24.0133" stroke="#7C86FF" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M23.0932 6.66602H8.9065C7.58688 6.66632 6.31422 7.15585 5.33455 8.03997C4.35488 8.92408 3.73777 10.14 3.6025 11.4527C3.5945 11.522 3.58917 11.5873 3.57984 11.6553C3.47184 12.554 2.6665 19.274 2.6665 21.3327C2.6665 22.3935 3.08793 23.411 3.83808 24.1611C4.58822 24.9113 5.60564 25.3327 6.6665 25.3327C7.99984 25.3327 8.6665 24.666 9.33317 23.9993L11.2185 22.114C11.7185 21.6139 12.3967 21.3328 13.1038 21.3327H18.8958C19.603 21.3328 20.2812 21.6139 20.7812 22.114L22.6665 23.9993C23.3332 24.666 23.9998 25.3327 25.3332 25.3327C26.394 25.3327 27.4115 24.9113 28.1616 24.1611C28.9117 23.411 29.3332 22.3935 29.3332 21.3327C29.3332 19.2727 28.5278 12.554 28.4198 11.6553C28.4105 11.5887 28.4052 11.522 28.3972 11.454C28.2622 10.1411 27.6452 8.92485 26.6655 8.04046C25.6858 7.15607 24.413 6.66636 23.0932 6.66602Z" stroke="#7C86FF" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </a>
                <h4>Discord</h4>
                <p>A space for builders and operators working on AI infrastructure.</p>
              </div>

              <div className="community-icon-item">
                <a 
                  href="https://www.instagram.com/aedify.ai/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="community-icon-link"
                >
                  <div className="community-icon-circle">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.6665 2.66602H9.33317C5.65127 2.66602 2.6665 5.65078 2.6665 9.33268V22.666C2.6665 26.3479 5.65127 29.3327 9.33317 29.3327H22.6665C26.3484 29.3327 29.3332 26.3479 29.3332 22.666V9.33268C29.3332 5.65078 26.3484 2.66602 22.6665 2.66602Z" stroke="#FB64B6" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M21.3331 15.1604C21.4977 16.2701 21.3081 17.4034 20.7915 18.3991C20.2748 19.3948 19.4573 20.2023 18.4553 20.7066C17.4532 21.211 16.3177 21.3865 15.2102 21.2083C14.1026 21.0301 13.0795 20.5072 12.2862 19.714C11.493 18.9207 10.9701 17.8976 10.7919 16.79C10.6136 15.6825 10.7892 14.5469 11.2935 13.5449C11.7979 12.5429 12.6054 11.7254 13.6011 11.2087C14.5968 10.6921 15.7301 10.5025 16.8398 10.6671C17.9717 10.8349 19.0196 11.3624 19.8287 12.1715C20.6378 12.9806 21.1653 14.0285 21.3331 15.1604Z" stroke="#FB64B6" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M23.3335 8.66602H23.3468" stroke="#FB64B6" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
          </div>
                </a>
                <h4>Instagram</h4>
                <p>Behind-the-scenes moments from the team and the platform.</p>
          </div>
        </div>
      </section>

          <section id="community-guidelines" className="community-section">
        <h2>Community Guidelines</h2>
        <p>
          To ensure a positive and helpful community experience, please follow these guidelines:
        </p>
        <ul>
          <li>Be respectful and inclusive</li>
          <li>Share knowledge and help others</li>
          <li>Search before asking questions</li>
          <li>Provide clear and detailed information when asking for help</li>
          <li>Follow platform terms of service</li>
        </ul>
      </section>

          <section id="community-resources" className="community-section">
        <h2>Community Resources</h2>
        <ul>
          <li><strong>Showcase:</strong> Share your projects built on Aedify.AI</li>
          <li><strong>Tutorials:</strong> Learn from community-created tutorials</li>
          <li><strong>Examples:</strong> Browse example projects and code samples</li>
          <li><strong>Events:</strong> Join webinars, meetups, and workshops</li>
        </ul>
      </section>

          <section id="community-contributing" className="community-section">
        <h2>Contributing</h2>
        <p>
          Want to contribute to the community? Here are some ways you can help:
        </p>
        <ul>
          <li>Answer questions in the forums</li>
          <li>Share tutorials and guides</li>
          <li>Report bugs and suggest features</li>
          <li>Contribute to documentation</li>
          <li>Create example projects</li>
        </ul>
      </section>

          <PageNavigation />
        </div>

        {/* Right Sidebar - Section Navigation */}
        <aside className="community-sidebar">
          <div className="sidebar-section">
            <h3>Contents</h3>
            <nav className="section-nav">
              {sections.map((section) => (
                <a
                  key={section.id}
                  href={`#community-${section.id}`}
                  className={`section-nav-item ${activeSection === section.id ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault()
                    setActiveSection(section.id)
                    document.getElementById(`community-${section.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
                  }}
                >
                  {section.title}
                </a>
              ))}
            </nav>
          </div>
        </aside>
      </div>
    </div>
  )
}

export default Community
